const getObjectFromQueryString = (string) => {
  // обрезаем '?'
  let queryString = string.slice(1, string.length);

  // берем каждую пару ключ-значение (они отделены через &)
  const filters = queryString.split('&')
    .reduce((res, filter) => {
      // дробим ее на ключ и на значение
      const filterData = filter.split('=');

      if (res[filterData[0]]) {
        res[filterData[0]].push(filterData[1]);
      } else {
        res[filterData[0]] = [filterData[1]];
      }

      return res;
    }, {});

  return filters;
};

export default getObjectFromQueryString;



// WEBPACK FOOTER //
// ./src/utils/getObjectFromQueryString.js